<template>
    <div>
        <!-- Desativado: indicadores do topo (a lista ficou basica, em tabela).
        <section class="case-stats mb-5" aria-label="Indicadores dos casos">
            <div v-for="kpi in kpis" :key="kpi.label" class="case-stat">
                <span class="case-stat__label">{{ kpi.label }}</span>
                <span class="case-stat__value">{{ kpi.value }}</span>
                <span class="case-stat__hint">{{ kpi.hint }}</span>
            </div>
        </section>
        -->

        <div class="ui-list-bar">
            <ui-pills v-model="statusTab" :items="pillItems" @input="page = 1" />
        </div>

        <!-- Lista de casos em tabela, como as outras listas: clicar na linha abre a Central do caso. -->
        <ui-table-card clearable :can-clear="!!search || statusTab !== 'all'" @clear="clearFilters">
            <template #toolbar>
                <v-text-field v-model="search" placeholder="Buscar pelo nome do caso" dense outlined hide-details clearable
                    prepend-inner-icon="mdi-magnify" class="ui-toolbar__search" @input="page = 1"></v-text-field>
            </template>
            <v-data-table :headers="headers" :items="visibleCases" :loading="loading" disable-sort hide-default-footer item-key="id"
                :page.sync="page" :items-per-page="itemsPerPage" no-data-text="Nenhum caso para este filtro" loading-text="Carregando casos..."
                class="ui-clickable-rows" @click:row="(item) => $emit('open', item)">
                <template v-slot:[`item.name`]="{ item }">
                    <div class="ui-cell-main">{{ item.name }}</div>
                    <div class="ui-cell-sub">{{ typeLabel(item.type) }} · {{ stageLabel(item.qgc_stage) }}</div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <ui-badge :text="phase(item).text" :tone="phase(item).tone" />
                    <div v-if="item.habdiv.status !== 'none'" class="ui-cell-sub">{{ phase(item).hint }}</div>
                </template>
                <template v-slot:[`item.official_letters`]="{ item }">
                    {{ item.official_letters }}
                    <div v-if="item.official_letters_pending" class="ui-cell-sub case-card__warn">{{ item.official_letters_pending }} sem fundamentação</div>
                </template>
                <template v-slot:[`item.progress`]="{ item }">
                    <div class="d-flex align-center" style="gap: 8px; min-width: 130px;">
                        <v-progress-linear :value="percent(item)" height="6" rounded :color="item.items_total && item.items_analyzed === item.items_total ? 'success' : 'primary'" background-color="#eef0f3"></v-progress-linear>
                        <span class="ui-nowrap ui-small">{{ item.items_analyzed }}/{{ item.items_total }}</span>
                    </div>
                </template>
                <template v-slot:[`item.actions`]><v-icon small class="ui-cell-chevron">mdi-chevron-right</v-icon></template>
            </v-data-table>
            <template #footer>
                <ui-pagination :total="visibleCases.length" :page.sync="page" :items-per-page.sync="itemsPerPage" />
            </template>
        </ui-table-card>

        <!-- Desativado: cards dos casos (substituidos pela tabela acima).
        <div v-if="loading && !cases.length" class="ui-card"><ui-empty icon="mdi-briefcase-search-outline" text="Carregando casos..." /></div>
        <div v-else-if="!visibleCases.length" class="ui-card"><ui-empty icon="mdi-briefcase-search-outline" text="Nenhum caso para este filtro" /></div>

        <div v-else class="case-grid">
            <button v-for="item in visibleCases" :key="item.id" type="button" class="ui-card case-card" @click="$emit('open', item)">
                <div class="case-card__head">
                    <div style="min-width: 0;">
                        <div class="case-card__name">{{ item.name }}</div>
                        <div class="ui-small ui-muted">{{ typeLabel(item.type) }} · {{ stageLabel(item.qgc_stage) }}</div>
                    </div>
                    <v-icon small class="ui-cell-chevron">mdi-chevron-right</v-icon>
                </div>

                <div class="case-card__phase">
                    <ui-badge :text="phase(item).text" :tone="phase(item).tone" />
                    <span class="ui-small ui-muted">{{ phase(item).hint }}</span>
                </div>

                <div class="case-card__numbers">
                    <div><strong>{{ item.habilitations }}</strong><span>Habilitações</span></div>
                    <div><strong>{{ item.divergences }}</strong><span>Divergências</span></div>
                    <div><strong>{{ item.official_letters }}</strong><span>Análises de ofício</span></div>
                    <div><strong>{{ item.document_request_creditors }}</strong><span>Credores com docs solicitados</span></div>
                </div>

                <div class="case-card__progress">
                    <div class="d-flex align-center ui-small mb-1">
                        <span>Pedidos analisados</span>
                        <v-spacer></v-spacer>
                        <span class="font-weight-medium">{{ item.items_analyzed }}/{{ item.items_total }}</span>
                    </div>
                    <v-progress-linear :value="percent(item)" height="6" rounded :color="item.items_total && item.items_analyzed === item.items_total ? 'success' : 'primary'" background-color="#eef0f3"></v-progress-linear>
                    <div class="ui-small ui-muted mt-1">
                        {{ item.qgc_creditors }} credores no QGC
                        <span v-if="item.official_letters_pending" class="case-card__warn"> · {{ item.official_letters_pending }} ofício(s) sem fundamentação</span>
                    </div>
                </div>
            </button>
        </div>
        -->
    </div>
</template>

<script>
import clientTypes from "@/common/data/client-types.data";
import { habdivPhase } from "@/common/util/credit-analysis-case.util";

// Central de Creditos: tela inicial com um card por caso (prazo de hab/div,
// pedidos, analises de oficio, documentos solicitados e progresso).

export default {
    name: "CreditAnalysisCaseBoard",

    props: {
        cases: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },

    data: () => ({
        search: "",
        statusTab: "all",
        page: 1,
        itemsPerPage: 25,
        headers: [
            { text: "Caso", value: "name" },
            { text: "Status", value: "status" },
            { text: "Credores", value: "qgc_creditors", align: "end" },
            { text: "Habilitações", value: "habilitations", align: "end" },
            { text: "Divergências", value: "divergences", align: "end" },
            { text: "Análises de ofício", value: "official_letters", align: "end" },
            { text: "Pedidos analisados", value: "progress" },
            { text: "", value: "actions", align: "end", width: 40 },
        ],
    }),

    computed: {
        pillItems() {
            const count = (status) => this.cases.filter((item) => item.habdiv.status === status).length;
            return [
                { value: "all", text: `Todos (${this.cases.length})` },
                { value: "open", text: `Prazo aberto (${count("open")})` },
                { value: "closed", text: `Prazo encerrado (${count("closed")})` },
                { value: "none", text: `Sem prazo (${count("none") + count("not_started")})` },
            ];
        },

        visibleCases() {
            const term = this.normalize(this.search);
            return this.cases
                .filter((item) => {
                    if (this.statusTab === "none") return ["none", "not_started"].includes(item.habdiv.status);
                    return this.statusTab === "all" || item.habdiv.status === this.statusTab;
                })
                .filter((item) => !term || this.normalize(item.name).includes(term))
                // Casos com pedidos ou prazo aberto primeiro.
                .slice()
                .sort((a, b) => (b.requests_total + b.official_letters > 0) - (a.requests_total + a.official_letters > 0)
                    || (b.habdiv.status === "open") - (a.habdiv.status === "open")
                    || a.name.localeCompare(b.name, "pt-BR"));
        },

        kpis() {
            const sum = (key) => this.cases.reduce((total, item) => total + (Number(item[key]) || 0), 0);
            return [
                { label: "Casos com prazo aberto", value: this.cases.filter((item) => item.habdiv.status === "open").length, hint: `de ${this.cases.length} casos` },
                { label: "Pedidos de hab/div", value: sum("requests_total"), hint: `${sum("habilitations")} habilitações · ${sum("divergences")} divergências` },
                { label: "Análises de ofício", value: sum("official_letters"), hint: `${sum("official_letters_pending")} sem fundamentação` },
                { label: "Credores com docs solicitados", value: sum("document_request_creditors"), hint: "pela Central" },
            ];
        },
    },

    methods: {
        clearFilters() {
            this.search = "";
            this.statusTab = "all";
            this.page = 1;
        },

        normalize(value) {
            return String(value || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
        },

        typeLabel(type) {
            const found = clientTypes.find((item) => item.id === Number(type));
            return found ? found.name : "Caso";
        },

        stageLabel(stage) {
            return ({ 1: "Edital Art. 52", 2: "Edital Art. 7", 3: "QGC Consolidado" })[Number(stage)] || "Sem QGC";
        },

        phase(item) {
            return habdivPhase(item.habdiv);
        },

        percent(item) {
            return item.items_total ? Math.round((item.items_analyzed / item.items_total) * 100) : 0;
        },
    },
};
</script>

<style scoped>
.case-stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
}

.case-stat {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 14px 16px;
    border: 1px solid #e6e2ee;
    border-radius: 10px;
    background: #fff;
}

.case-stat__label {
    font-size: 12.5px;
    color: #6b6880;
}

.case-stat__value {
    font-size: 26px;
    font-weight: 600;
    color: #1d0533;
}

.case-stat__hint {
    font-size: 12px;
    color: #6b6880;
}

.case-board-search {
    max-width: 320px;
}

.case-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 14px;
}

.case-card {
    /* sem a margem padrao entre cards seguidos (.ui-card + .ui-card) */
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.case-card:hover,
.case-card:focus-visible {
    border-color: #a78bfa;
    box-shadow: 0 2px 10px rgba(29, 5, 51, 0.08);
}

.case-card__head {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    justify-content: space-between;
}

.case-card__name {
    font-weight: 600;
    font-size: 15px;
    color: #1d0533;
}

.case-card__phase {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.case-card__numbers {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 12px;
}

.case-card__numbers div {
    display: flex;
    flex-direction: column;
}

.case-card__numbers strong {
    font-size: 18px;
    color: #1d0533;
}

.case-card__numbers span {
    font-size: 12px;
    color: #6b6880;
}

.case-card__warn {
    color: #b45309;
}

@media (max-width: 960px) {
    .case-stats {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>
